module.exports = __webpack_public_path__ + "videos/video-1792.06bb411.webm";